// extracted by mini-css-extract-plugin
export default {"container":"TextBig_container__y0XsD","containerInput":"TextBig_containerInput__oj+Fx","input":"TextBig_input__jOH6U"};